import React from 'react';
import { ChevronRightIcon, ShieldCheckIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import { ProductVisualView } from './ProductVisualView';
import type { ProductPageContent } from '../../types/product';
type ProductHeroProps = {
  product: ProductPageContent;
};
export function ProductHero({
  product
}: ProductHeroProps) {
  const Icon = product.icon;
  const {
    hero
  } = product;
  return <section className="hero-surface w-full overflow-hidden" aria-labelledby="product-hero-heading" data-id="element-1191" data-mp="faqxozef2txs">
      <div className="mx-auto max-w-shell px-6 pb-16 pt-6 lg:pb-24" data-id="element-1192" data-mp="ja86a1p54776">
        <nav aria-label="Breadcrumb" data-id="element-1193" data-mp="5k4mrihnarlf">
          <ol className="flex items-center gap-1.5 text-[13px] text-ink-muted" data-id="element-1194" data-mp="5j3e1ko3qh6v">
            <li data-id="element-1195" data-mp="ai6aigq0nf38">
              <SmartLink href="/" className="transition-colors duration-150 ease-out hover:text-ink" data-id="element-1196" data-mp="ahocpfnpgst7">
                Products
              </SmartLink>
            </li>
            <li aria-hidden="true" data-id="element-1197" data-mp="12zsdx8thr9dm">
              <ChevronRightIcon className="h-3.5 w-3.5" data-id="element-1198" data-mp="130tlv4f7nfr4" />
            </li>
            <li aria-current="page" className="font-medium text-ink" data-id="element-1199" data-mp="2hfr06477un13">
              {product.name}
            </li>
          </ol>
        </nav>

        <div className="mt-10 grid grid-cols-1 items-center gap-12 lg:mt-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)] lg:gap-14" data-id="element-1200" data-mp="2db15gioanehr">
          <div className="max-w-[540px]" data-id="element-1201" data-mp="2mdad90s6gtrg">
            <p className="inline-flex items-center gap-2 text-[14px] font-semibold text-ink" data-id="element-1202" data-mp="2mc92yyizkbas">
              <span className="flex h-7 w-7 items-center justify-center rounded-[8px] border border-canvas-line bg-white text-brand" data-id="element-1203" data-mp="31156qje0f25l">
                <Icon className="h-4 w-4" strokeWidth={1.9} aria-hidden="true" data-id="element-1204" data-mp="2w5y6jljy8flf" />
              </span>
              {product.name}
            </p>
            <h1 id="product-hero-heading" className="display mt-5 text-[38px] font-semibold text-ink sm:text-[50px] lg:text-[56px]" data-id="element-1205" data-mp="355cxem412s6g">
              {hero.headline}
            </h1>
            <p className="mt-6 max-w-[480px] text-[18px] leading-[1.5] text-ink-muted" data-id="element-1206" data-mp="1artusxv54jea">
              {hero.subheadline}
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-3" data-id="element-1207" data-mp="3frlggjnh9f8x">
              <SmartLink href={product.slug === 'business-finance' ? '/business-finance/apply' : '/get-started'} className="rounded-[7px] bg-brand px-5 py-3 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-hover" data-id="element-1208" data-mp="3frv8ecs31wh9">
                {product.slug === 'business-finance' ? 'Join early access' : 'Get started'}
              </SmartLink>
              <SmartLink href="/demo" className="rounded-[7px] border border-ink/20 bg-white px-5 py-3 text-[15px] font-semibold text-ink transition-colors duration-150 ease-out hover:border-ink/45" data-id="element-1209" data-mp="2iqh5lptjk30">
                Book a demo
              </SmartLink>
            </div>
            <p className="mt-6 flex items-center gap-2 text-[13px] text-ink-muted" data-id="element-1210" data-mp="lbb5cpukp10h">
              <ShieldCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-1211" data-mp="25tloiig2ir26" />
              {hero.trustLine}
            </p>
          </div>

          <ProductVisualView visual={hero.visual} data-id="element-1212" data-mp="20tr0cmnogfkt" />
        </div>
      </div>
    </section>;
}